import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useRetryFetch from "../hooks/useRetryFetch";
import { tryGetUserRoles } from "../api/auth";

const LoginFromGoogle = () => {
  const { setAuth } = useAuth();
  const retryFetch = useRetryFetch();
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const redirect = () => {
    let oldLocationState = sessionStorage.getItem("locationstate");
    if (oldLocationState) {
      const from = JSON.parse(oldLocationState).from;
      const fromPathname = from?.pathname || "/portal";
      const fromSearch = from?.search || "";
      const fromHash = from?.hash || "";
      sessionStorage.removeItem("locationstate");
      const prefix = fromSearch ? '&' : '?';
      const timestamp = `${prefix}t=${Date.now()}`;
      navigate(`${fromPathname}${fromSearch}${timestamp}${fromHash}`, { replace: true });
    } else {
      navigate(`/portal?t=${Date.now()}`);
    }
  };

  const loadUserRoles = async ({ email, accessToken }) => {
    const authData = { email, accessToken };
    setAuth(authData); // accessToken must be set to call use roles API
    localStorage.setItem("auth", JSON.stringify(authData));
    const roles = await tryGetUserRoles(retryFetch);
    if (Array.isArray(roles)) {
      console.log(`loadUserRoles storing auth ${email} with roles ${roles}`);
      authData.roles = roles;
      setAuth(authData);
      localStorage.setItem("auth", JSON.stringify(authData));
    }

    redirect();
  };

  useEffect(() => {
    let accessToken = searchParams.get("accessToken");
    let email = searchParams.get("email");
    console.log(`LoginFromGoogle.jsx found accessToken and email ${email}`);
    if (accessToken && email) {
      loadUserRoles({ email, accessToken }).catch(console.error);
    } else {
      navigate(`/login?t=${Date.now()}`);
    }
  }, []);

  return (
        <div className="loadingcenter">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/loading.gif"}
            alt=""
          />
        </div>
  );
};

export default LoginFromGoogle;
